import { StandardUserRoles } from '@quadminds/shared/commons';
import { StandardStorkRoles } from '../../enums';

export interface IOrganizationInviteSchema {
    id: string;
    name: string;
}

export interface IInviteTypologySchema {
    id: string;
    code: string;
    name: string;
}

export interface IInviteMetadataSchema {
    invitationLink?: string;
}

export interface IInviteSchema {
    id?: string;
    uuid: string;
    organization?: IOrganizationInviteSchema;
    email?: string;
    phone?: string;
    userExternalId?: string;
    settings?: Record<string, unknown>;
    status?: string;
    expiresAt: string;
    typology?: IInviteTypologySchema;
    permissions?: string[];
    application?: string;
    modules?: string[];
    metadata?: IInviteMetadataSchema;
    roles?: (StandardStorkRoles | StandardUserRoles)[];
    // Si el usuario logueado puede editar o eliminar esta invitacion
    canManage?: boolean;
}
